import { SET_ROOM, SET_HAND, UPDATE_FIELD, REMOVE_FROM_HAND, SET_PLAYER, ADD_TO_HAND } from "../types";


export const setRoom = (roomCode: Number) => {
    return {
        type: SET_ROOM,
        roomCode
    }
}

export const setHand = (hand: Array<String>) => {
    return {
        type: SET_HAND,
        hand
    }
}

export const setSelected = (key: Number) => {
    return {
        type: 'SET_SELECTED',
        key
    }
}

export const updateField = (col: number, row: number, char: string, player: number) => {
    return {
        type: UPDATE_FIELD,
        col, row, char, player
    }
}
export const addToBoard = (newBoard: Object[]) => {
    return {
        type: 'ADD_TO_BOARD',
        newBoard
    }
}

export const removeFromHand = (idx: number) => {
    return {
        type: REMOVE_FROM_HAND,
        idx
    }
}

export const addToHand = (item: string) => ({
    type: ADD_TO_HAND,
    item
})


export const setPlayer = (id: number) => {
    return {
        type: SET_PLAYER,
        id
    }
}
export const flipPlayers = (player: number) => {
    return {
        type: SET_PLAYER,
        id: player === 1 ? 2 : 1
    }
}
export const makeAvailable = (idx: Number[]) => {
    return {
        type: 'SET_AVAILABLE',
        idx
    }
}
export const emptyAvailable = () => ({
    type: 'EMPTY_AVAILABLE',

})

export const emptyCombat = () => ({
    type: 'EMPTY_COMBAT',

})
export const setCombat = (id: string) => ({
    type: 'SET_COMBAT',
    id
})

export const killedChar = (player: number, id: string) => ({
    type: 'ADD_KILLED_CHAR',
    id, player
})

export const emptyKills = () => ({
    type: 'EMPTY_KILLED_CHAR',

})

export const setWinner = (player: number) => ({
    type: 'SET_WINNER',
    player
})